<template>
  <assistant-step :title="$t(`${step.id}.title`)">
    <gc-form v-model="formValid" @submit.prevent="onSubmit()">
      <gc-row>
        <gc-col cols="12" sm="12">
          <form-field
            :form-data="formData"
            field-name="companyName"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col cols="12" sm="6">
          <form-field
            :form-data="formData"
            field-name="firstname"
            :step="step"
          ></form-field>
        </gc-col>
        <gc-col cols="12" sm="6">
          <form-field
            :form-data="formData"
            field-name="lastname"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col cols="12" sm="9">
          <form-field
            :form-data="formData"
            field-name="street"
            :step="step"
          ></form-field>
        </gc-col>
        <gc-col cols="12" sm="3">
          <form-field
            :form-data="formData"
            field-name="streetNumber"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col cols="12" sm="4">
          <form-field
            :form-data="formData"
            field-name="zipcode"
            :step="step"
          ></form-field>
        </gc-col>
        <gc-col cols="12" sm="8">
          <form-field
            :form-data="formData"
            field-name="city"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col>
          <form-field
            :form-data="formData"
            field-name="phone"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col>
          <form-field
            :form-data="formData"
            field-name="email"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col>
          <form-field
            :form-data="formData"
            field-name="installAddressDiffers"
            :step="step"
            :assistantContext="assistantContext"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row
        v-if="
          assistantContext.contactForm.installAddressDiffers.includes('yes')
        "
      >
        <gc-col>
          <label class="gc-block gc-text-sm gc-relative">{{
            $t(`${step.id}.formFields.installAddressLabel.label`)
          }}</label>
        </gc-col>
      </gc-row>
      <gc-row
        v-if="
          assistantContext.contactForm.installAddressDiffers.includes('yes')
        "
      >
        <gc-col cols="12" sm="9">
          <form-field
            :form-data="formData"
            field-name="installAddressStreet"
            :step="step"
          ></form-field>
        </gc-col>
        <gc-col cols="12" sm="3">
          <form-field
            :form-data="formData"
            field-name="installAddressStreetNumber"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row
        v-if="
          assistantContext.contactForm.installAddressDiffers.includes('yes')
        "
      >
        <gc-col cols="12" sm="4">
          <form-field
            :form-data="formData"
            field-name="installAddressZipcode"
            :step="step"
          ></form-field>
        </gc-col>
        <gc-col cols="12" sm="8">
          <form-field
            :form-data="formData"
            field-name="installAddressCity"
            :step="step"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col>
          <form-field
            :form-data="formData"
            field-name="privacyConfirmation"
            :step="step"
            hide-label
          >
            <template #label>
              <span
                @click.stop
                v-html="
                  $t(`${step.id}.formFields.privacyConfirmation.headline`)
                "
              />
            </template>
          </form-field>
        </gc-col>
      </gc-row>
    </gc-form>

    <assistant-step-navigation
      :assistantContext="assistantContext"
      :step="step"
      :steps="steps"
      :submit="step.submit"
      :valid="formValid"
      :show-back-button="true"
      @next="onNext()"
      @prev="onPrev()"
    />
  </assistant-step>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';
import AssistantStep from '@/components/AssistantStep.vue';
import GcForm from '@/components/primitives/GcForm.vue';
import AssistantStepNavigation from '@/components/AssistantStepNavigation.vue';
import { getStepContext } from '@/lib/context';
import { stepComponentProps } from '@/lib/steps/helper';
import FormField from '@/components/FormField.vue';
import { useBaseTransitions } from '@/lib/xstate/transitions';
import GcCol from '@/components/primitives/GcCol.vue';
import GcRow from '@/components/primitives/GcRow.vue';

export default defineComponent({
  components: {
    AssistantStep,
    AssistantStepNavigation,
    FormField,
    GcCol,
    GcForm,
    GcRow,
  },
  props: {
    ...stepComponentProps,
  },
  setup: (props, { emit }) => {
    const { onNext, onPrev } = useBaseTransitions(
      emit,
      props.assistantContext,
      props.step,
    );
    const formData = getStepContext(props.assistantContext, props.step);
    const formValid = ref(false);

    return {
      formData,
      formValid,
      onNext,
      onPrev,
    };
  },
});
</script>
